import { getFindingAPIDurationFilter } from "utils/dateUtils";
import { modifyFilters } from "./FindingAPI";
import { makeCancellableAPIRequest } from "./index";
import _ from "lodash";

const DashboardAPI = {
    getProductsWithRiskScoreV2(queryParams = {}, BUaggregation = false) {
        const path = BUaggregation ? `/api/businessunits/dashboard/compliance/elastic/enterprise-risk` : `/compliance/enterprise-risk`
        return makeCancellableAPIRequest(
            "GET",
            path,
            {
                params: queryParams
            }
        );
    },
    getProductRiskScore(queryParams = {}, product = "", subProductId) {
        let url = `/compliance/product-risk/${product}`;
        if(subProductId){
            url += `/subproduct/${subProductId}`
        }
        return makeCancellableAPIRequest(
            "GET",
            url,
            {
                params: queryParams
            }
        );
    },
    getSubProductRiskScore(queryParams = {}, subproduct = "") {
        return makeCancellableAPIRequest(
            "GET",
            `/compliance/subproduct-risks/${subproduct}`,
            {
                params: queryParams
            }
        )
    },
    getComplianceData(queryParams = {}, BUaggregation = false) {
        const path = BUaggregation ? "/api/businessunits/dashboard/compliance/policy/reports" :"/compliance/policy/reports"
        return makeCancellableAPIRequest(
            "GET",
            path,
            {
                params: queryParams
            }
        )
    },
    getToolsData(productId, subproductId) {
        let url = `/user/tools/status?productId=${productId}`;
        if(subproductId){
            url += `&subProductId=${subproductId}`
        }
        return makeCancellableAPIRequest(
            "GET",
            url
        )
    },
    getTopProductsAllBU(params = {}) {
        const path = "/api/businessunits/dashboard/product/elastic/top";
        return makeCancellableAPIRequest(
            "GET",
            path,
            {
                params
            }
        )
    },
    getTopProducts(params = {}) {
        const path = "/api/dashboard/top/product"
        return makeCancellableAPIRequest(
            "POST",
            path,
            {
                data: params
            }
        )
    },
    getTopSubProducts(params = {}) {
        const path = "/api/dashboard/top/sub-product"
        return makeCancellableAPIRequest(
            "POST",
            path,
            {
                data: params
            }
        )
    },
    getComplianceStatusData(productId,subproductId,environmentName) {
        let url = `/compliance/policy/status?productId=${productId}`
        if(subproductId){
            url += `&subProductId=${subproductId}`
        }
        if(environmentName){
            url += `&environmentName=${environmentName}`
        }
        return makeCancellableAPIRequest(
            "GET",
            url
        )
    },
    getBuildVersion() {
        return makeCancellableAPIRequest(
            "GET",
            "/public/version"
        )
    },
    getClosedTiketsPerWeeks(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/stats/weekly?status=DONE",
            {
                params
            }
        )
    },
    getFindingSLA(BUaggregation = false){
        const path = BUaggregation ?"/api/businessunits/dashboard/findingSla" : "/user/findingSla"
        return makeCancellableAPIRequest(
            "GET",
            path,
        ) 
    },
    getSLAGraphData(data, BUaggregation = false, isSLAV2 = false) {
        data = modifyFilters(data);
        const path = BUaggregation ? "/api/businessunits/dashboard/findingSla/sla-trend" : "/user/findingSla/sla-trend"
        const _data = {
            aggFields : ["severity"],
            filters: {
                ...data.filters,
            },
            ...(isSLAV2 && { ignoreMitigated : false, ignoreDuplicate : true }),
        };
        return makeCancellableAPIRequest(
            "POST",
            path,
            {
                data: _data
            }
        )
    },
    getResolutionSLA(data, BUaggregation = false, isSLAV2 = false) {
        data = modifyFilters(data);
        // const _filters = getFindingAPIDurationFilter(filters, selectedDuration, startDate, endDate);
        const _data = {
            ...data,
            aggFields : ["severity"],
            filters: {
                resolutionSlaBreached: [true],
                ...data.filters,
            },
            // existsFilters : ["firstResponse"],
            ignoreMitigated : false,
            ...(isSLAV2 && { ignoreDuplicate : true }),
        };
        const path = BUaggregation ? "/api/businessunits/dashboard/findingSla/sla-trend" : "/user/findingSla/sla-trend"
        return makeCancellableAPIRequest(
            "POST",
            path,
            {
                data: _data
            }
        )
    },
    getSLABuildFailures(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/api/build/status/count",
            {
                params
            }
        );
    },
    getSLAStatsByOwner(filters){
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingSla/due-sla-stats",
            {
                data: {
                    filters,
                    aggField: "severity"
                }
            }
        );
    },
    getAverateRemediateTime(data = {}) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingSla/remediation",
            {
                data
            }
        );
    },
    getMTTRTrend(data = {}) {
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            "api/finding-sla/mean-remediation-stats",
            {
                data
            }
        );
    },
    getSLAStats(data, allBUAggregated = false) {
        data = modifyFilters(data);
        const path = allBUAggregated ? '/api/businessunits/dashboard/sla-stats/top' : '/user/findingSla/sla-stats/top';
        return makeCancellableAPIRequest(
            'POST',
            path,
            {
                data
            }
        );
    },
    getRiskTrendForProducts(params) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/product/risk/stats",
            {
                data: params
            }
        );
    },
    getRiskTrendForBu(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/api/risk-stats/bu-trend",
            {
                params
            }
        );
    },
    getROI(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/api/businessunits/dashboard/roi",
            {
                params
            }
        );
    },
    getScanSummary(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/scans/stats",
            {
                data
            }
        );
    },
    getRemediationEffectiveness(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/businessunits/dashboard/remediation-effectiveness",
            {
                data
            }
        );
    },
    getCurrentFindingsByDueDate(data){
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            "/user/findings/findingStats/due-date",
            {
                data
            }
        );
    },
    getCurrentFindingsByFoundOn(data){
        data = modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            "/user/findings/findingStats/found-on",
            {
                data
            }
        );
    },
    getUnmappedRepoStats(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/repos/stats"
        );
    },
    getUnmappedSecTools(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/generic/unmapped-projects-stats"
        );
    },
    getTicketStats(params){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/all/jira/ticket/stats",
            {
                data: {
                    params
                }
            }
        );
    },
    getTicketStatsByScanTypeVsPriority(params){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/ticket/by-scan-type/stats",
            {
                data: params
            }
        );
    },
    getFindingTrendByBU(data){
        data.filters = getFindingAPIDurationFilter(data.filters, data.selectedDuration, data.startDate, data.endDate);
        if(data.filters.foundOn){
            data.filters.createdAt = data.filters.foundOn;
            delete data.filters.foundOn;
        }
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingStats/trend-by-bu",
            {
                data: _.omitBy(data, ["selectedDuration", "startDate", "endDate"]),
            }
        );
    },
    getSubProductVSTicketWidget(params){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/ticket/by-status/stats",
            {
              data: params
            }
          )
    },
    getTicketSLA(params){
        return makeCancellableAPIRequest(
            "GET",
            "user/tickets/jira/stats/by-sla",
            {
              params
            }
        )
    },
    getTicketRiskScore(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/risk",
            {
                params
            }
        )
    },
    getTicketRiskScoreTimeLine(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/risk-timeline",
            {
                params
            }
        )
    },
    getOverAllRiskScoreV2(data){
        return makeCancellableAPIRequest(
            "POST",
            "/compliance/filters/enterprise-risk",
            {
                data
            }
        )
    },
    getAllGroups(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/groups",
        )
    },
    getAllFilteredGroups(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/groups/filter/global",
        )
    },
    moveGroup(sourceGroups, targetGroups) {
        return makeCancellableAPIRequest(
            'PUT',
            '/api/groups/move',
            {
                data: {
                    sourceGroups,
                    targetGroups
                }
            }
        )
    },
    hierarchyAction(data, type){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/groups/${type}`,
            {
                data
            }
        );
    },
    getDevicesByProduct(params){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/asset/count-by-product/stats",
            {
                data: params
            }
        )
    },
    getApplicationRiskStats(params){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/enterprise-product/stats",
            {
                data: params
            }
        )
    },
    getJWTToken(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/jwt",
        )
    },
    getUnresolvedTimelineRequest(params) {
        return makeCancellableAPIRequest(
            'POST',
            '/user/findings/unresolved/timeline',
            {
                data: params
            }
        )
    },
    getUnresolvedPollingTimeline(id) {
        return makeCancellableAPIRequest(
            'GET',
            `/user/findings/unresolved/timeline/${id}`
        )
    }
}



export default DashboardAPI;
